import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.17006 1C0.983808 1.1874 0.879272 1.44082 0.879272 1.705C0.879272 1.96918 0.983808 2.22263 1.17006 2.41L4.71006 6L1.17006 9.54C0.983808 9.72737 0.879272 9.98082 0.879272 10.245C0.879272 10.5092 0.983808 10.7626 1.17006 10.95C1.26303 11.0437 1.37363 11.1181 1.49549 11.1689C1.61735 11.2197 1.74805 11.2458 1.88006 11.2458C2.01207 11.2458 2.14278 11.2197 2.26464 11.1689C2.3865 11.1181 2.4971 11.0437 2.59006 10.95L6.83006 6.71C6.92379 6.61704 6.99818 6.50644 7.04895 6.38458C7.09972 6.26272 7.12586 6.13202 7.12586 6C7.12586 5.86798 7.09972 5.73729 7.04895 5.61542C6.99818 5.49356 6.92379 5.38297 6.83006 5.29L2.59006 1C2.4971 0.906274 2.3865 0.831878 2.26464 0.78111C2.14278 0.730343 2.01207 0.704204 1.88006 0.704204C1.74805 0.704204 1.61735 0.730343 1.49549 0.78111C1.37363 0.831878 1.26303 0.906274 1.17006 1Z",
		fill: "black"
	})
});
export default SvgRight;
